import { strategyToOptions } from "@/common/utils/strategyToOptions";

export const reportFileTypes = {
  csv: 'CSV',
  xlsx: 'Excel (XLSX)',
  txt: 'Texto (TXT)',
  pdf: 'PDF'
};

export const reportFileTypesOptions = strategyToOptions(reportFileTypes);
